import React from "react";
import { Tab } from "semantic-ui-react";

import { Caption, ExplanationHeader, List, ListItem, SourceLink } from "./common";

const LeverLearnPane = () => {
  return <Tab.Pane attached={true}>
      <Caption>
        In order to model your city, we need more information about your
        present-day population and GDP. Input these values to the best of your
        knowledge. From these two values, we provide four estimates that
        you are able to edit to adjust for your specific city.
      </Caption>

    <ExplanationHeader>Estimates</ExplanationHeader>
      <List>
        <ListItem>Population Growth Rate: Annual growth rate</ListItem>
        <ListItem>Economic (GDP) Growth Rate: Annual growth rate</ListItem>
        <ListItem>Modal Split: The percentage of kilometers traveled per mode, or type of motorized
        vehicle -- omitting non-motorized transit such as walking and biking.</ListItem>
        <ListItem>Passenger-Kilomometer Travel Demand (PKT/Capita): How much the average person in your city travels in a year</ListItem>
      </List>

      <ExplanationHeader> Data Sources for Estimates</ExplanationHeader>

      <List>
        <ListItem>Population Growth Rate: National GR of India</ListItem>
        <ListItem>GDP Growth Rate: National GR of India </ListItem>
        <ListItem>
          Modal Split: <SourceLink href="http://planningcommission.nic.in/sectors/NTDPC/voulme3_p2/urban_v3_p2.pdf" target="_blank">
            National Transport Development Committee. "Urban Transport"
          </SourceLink>
        </ListItem>
        <ListItem>
          PKT/Capita:
          <SourceLink href="https://www.naefrontiers.org/File.aspx?id=21923" target="_blank">
            Andreas Schafer. “Long-Term Trends in Global Passenger Mobility”. University of Cambridge.
          </SourceLink>
        </ListItem>
      </List>
    </Tab.Pane>;
};

export default LeverLearnPane;



// WEBPACK FOOTER //
// ./src/pages/modelCity/panes/learnMore.js